module.exports = __webpack_public_path__ + "static/img/loading.9dc47584.gif";